import React, { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

// Floating "back to top" button. Pass a scroll container ref (optional);
// defaults to the window.
export default function ScrollToTop({ getScrollEl }) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const el = (getScrollEl && getScrollEl()) || window;
    const target = el === window ? document.documentElement : el;
    const onScroll = () => {
      const y = el === window ? window.scrollY : el.scrollTop;
      setShow(y > 400);
    };
    el.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => el.removeEventListener("scroll", onScroll);
  }, [getScrollEl]);

  const toTop = () => {
    const el = (getScrollEl && getScrollEl()) || window;
    if (el === window) window.scrollTo({ top: 0, behavior: "smooth" });
    else el.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      type="button"
      onClick={toTop}
      aria-label="العودة إلى الأعلى"
      data-testid="scroll-to-top-btn"
      className={`fixed bottom-5 left-5 z-50 w-11 h-11 sm:w-12 sm:h-12 rounded-full bg-primary text-white shadow-lg shadow-primary/30 flex items-center justify-center transition-all duration-300 hover:bg-primary/90 hover:-translate-y-0.5 ${
        show ? "opacity-100 translate-y-0 pointer-events-auto" : "opacity-0 translate-y-4 pointer-events-none"
      }`}
    >
      <ArrowUp className="w-5 h-5" />
    </button>
  );
}
